import { CLEAR_ALL, LOGOUT } from '../../../store/Types';

export const ACTIVO_MODULOS = 'ACTIVO_MODULOS';

const initialState = {
  activo: null,
};

export const systemReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIVO_MODULOS:
      return {
        ...state,
        activo: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
